import { Component, Inject, OnInit } from '@angular/core';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import {
  BrnOverlayService,
  BRN_OVERLAY_REF,
} from 'projects/brn-frontend/src/app/core/services/brn-overlay.service';
import { BotSelectors } from 'projects/brn-frontend/src/app/core/store/bot/bot.selectors';
import { RunScenario } from '../../store';

@Component({
  selector: 'brn-scenarios-popup',
  templateUrl: './scenarios-popup.component.html',
  styleUrls: ['./scenarios-popup.component.scss'],
})
export class ScenariosPopupComponent implements OnInit {
  @ViewSelectSnapshot(BotSelectors.scenarios)
  scenarios!: any[];
  constructor(
    @Inject(BRN_OVERLAY_REF) public data: any,
    private overlay: BrnOverlayService,
    private store: Store
  ) {}

  ngOnInit(): void {}

  runScenario(scenario: any): void {
    const scenario_id = scenario.scenario_id;
    this.store.dispatch(new RunScenario(scenario_id));
    this.closeAll();
  }

  closeAll(): void {
    this.overlay.closeAll();
  }
}
